import React from 'react';
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import { SortableItem } from 'components/SortableItem';

import { DragMenu } from 'components/DragMenu';

import { LessonItem } from '../LessonItem';

import styles from './Lessons.module.scss';

const Lessons = ({
  courseReadOnly,
  structure,
  sensors,
  lessons,
  onLessonDragEnd,
  onEditLessonClick,
  onCopyLessonClick,
  onRemoveLessonClick,
}: {
  courseReadOnly: any;
  structure: any;
  sensors: any;
  lessons: any;
  onLessonDragEnd: any;
  onEditLessonClick: any;
  onCopyLessonClick: any;
  onRemoveLessonClick: any;
}) => (
  <div className={styles.lessons}>
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={onLessonDragEnd}
    >
      <SortableContext items={lessons} strategy={verticalListSortingStrategy}>
        {lessons.map((lesson: any) => (
          <SortableItem
            className={styles.lesson}
            key={lesson.id}
            id={lesson.id}
          >
            {({ listeners }: { listeners: any }) => (
              <>
                {!courseReadOnly && (
                  <DragMenu
                    className={styles.lessonMenu}
                    dragListeners={listeners}
                    onRemoveClick={() => onRemoveLessonClick(lesson)}
                  />
                )}
                <LessonItem
                  {...lesson}
                  courseReadOnly={courseReadOnly}
                  structure={structure}
                  onEditClick={onEditLessonClick}
                  onCopyClick={onCopyLessonClick}
                />
              </>
            )}
          </SortableItem>
        ))}
      </SortableContext>
    </DndContext>
  </div>
);

export default React.memo(Lessons) as any;
